import { useStore } from "effector-react";
import {createEffectorField} from "../../../shared/lib";

export const [$altenarStore, setAltenarStoreEvent] = createEffectorField<any>({
    defaultValue: null,
});

export const useAltenarStore = () => useStore($altenarStore);
